import { i as isEmpty_1 } from './isEmpty-51908328.js';
import { t as toString_1 } from './toString-10b0f228.js';
import { U as fractionDigits, V as LOCALE_FALLBACKS } from './currency-7be6806c.js';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString_1(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

var escapeRegExp_1 = escapeRegExp;

// Mostly taken from PESV3-14679 and UI/src/js/common/utils/formatters.js:26 in PES
const formatString = (str, replaceMap) => {
    if (!str || isEmpty_1(replaceMap)) {
        return str;
    }
    return Object.entries(replaceMap).reduce((acc, [placeholder, value]) => {
        return acc.replace(new RegExp(escapeRegExp_1(placeholder), 'g'), value);
    }, str);
};
const format = (value, { locale }) => {
    const locales = LOCALE_FALLBACKS[locale] || locale;
    const formatter = new Intl.NumberFormat(locales, {
        minimumFractionDigits: fractionDigits.MIN,
        maximumFractionDigits: fractionDigits.MAX,
    });
    return formatter.format(value);
};
const generateMedia = (minWidth, maxWidth) => {
    const minWidthValue = minWidth ? `(min-width:${minWidth}px)` : '';
    const maxWidthValue = maxWidth ? `(max-width:${maxWidth}px)` : '';
    if (minWidthValue && maxWidthValue) {
        return `${minWidthValue} and ${maxWidthValue}`;
    }
    return minWidthValue || maxWidthValue;
};
const decodeFromURI = (content) => decodeURIComponent(content.replace(/\+/g, '%20'));
const generateSrcSet = (urls) => {
    return urls === null || urls === void 0 ? void 0 : urls.join(',');
};

export { format as a, generateSrcSet as b, decodeFromURI as d, formatString as f, generateMedia as g };
